import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import { media } from '../../../src/js/utils/MediaQueries';
import gsap from 'gsap';

function toggleOpenMenu() {

    var menu = $qs('[data-target=menu]');
    var menuHamburger = $qs('[data-target=menu-hamburger]');
    var menuHamburgerTopLine = $qs('.top-line', menuHamburger);
    var menuHamburgerMiddleLine = $qs('.middle-line', menuHamburger);
    var menuHamburgerEndLine = $qs('.end-line', menuHamburger);
    var menuCover = $qs('[data-target=menu-cover]');
    var currentParent = $qs('.current_page_item');

    var menuTl = gsap.timeline();
    menuTl.pause();
    menuTl.to(menu, {
        x: 0,
        duration: 0.3,
        ease: "Power4.out"
    })
    menuTl.to($qs('body'), {
        overflow: 'hidden'
    })
    menuTl.to(menuCover, {
        opacity: 1,
        duration: 0.3,
        ease: "Power4.out",
        pointerEvents: "auto",
    }, "<")
    menuTl.to('.hamburger', {
        backgroundColor: '#FBAD16',
        duration: 0.3,
        ease: "Power4.out"
    },"<")
    menuTl.to('.menu-text', {
        color: '#18214c',
        duration: 0.3,
        ease: "Power4.out"
    },"<")
    menuTl.to(menuHamburgerTopLine, {
        y: 10,        
        duration: 0.2,
        ease: "Power4.out"
    },"<+=0.2")
    menuTl.to(menuHamburgerEndLine, {
        y: -10,        
        duration: 0.2,
        ease: "Power4.out"
    },"<")
    menuTl.to(menuHamburgerMiddleLine, {
        opacity: 0,
        duration: 0.2,
        ease: "Power4.out"
    },">")
    menuTl.to(menuHamburgerTopLine, {
        rotate: '45deg',    
        backgroundColor: "#18214C",    
        duration: 0.3,
        ease: "Power4.out"
    },">")
    menuTl.to(menuHamburgerEndLine, {
        rotate: '-45deg',        
        duration: 0.3,
        ease: "Power4.out",
        backgroundColor: "#18214C",
    },"<")

    // submenu
    var submenuTl = gsap.timeline();
    submenuTl.pause();
    var parentPage = $qsa('.menu-item-has-children > a');
    parentPage.forEach((parent) => {
        var parentEl = parent.parentNode;
        parent.addEventListener('click', function(event) {   
            event.preventDefault();                      
            var allSubmenus = $qsa('.sub-menu-wrap');
            allSubmenus.forEach((submenu) => {
                submenu.classList.remove('open-submenu');
            })
            var submenu = $qs('.sub-menu-wrap', parentEl);
            submenu.classList.add('open-submenu');            
        
            menu.setAttribute('data-state-submenu', 'closed')        
            // sub menu;
            if(window.innerWidth <= 575) {
                var xPerc = 0
                var xPercSub = -100 
            } else {
                var xPerc = -100
                var xPercSub = 0
            }
            submenuTl.to(menu, {
                xPercent: xPerc,
                duration: 0.3,
                ease: "Power4.out"
            },">")
            submenuTl.to(submenu, {
                xPercent:  xPercSub,
                duration: 0.3,
                ease: "power4.out"
            })
            var back = $qs('.back-menu', submenu);
            back.addEventListener('click', () => {
                submenuTl.to(submenu, {
                    xPercent: -1 * xPercSub,
                    duration: 0.3,
                    ease: "power4.out"
                })
            })

            // Open current submenu
            if(menu.getAttribute('data-state-submenu') == 'closed') {
                submenuTl.play();                  
                menu.setAttribute('data-state-submenu', 'open');
            } else {
                submenuTl.reverse();  
                menu.setAttribute('data-state-submenu', 'closed')
            }   

        })
    })

    menuHamburger.addEventListener('click', function(event) {                
        if(menu.getAttribute('data-state') == 'closed') {
            menuTl.play();          
            menu.setAttribute('data-state', 'open');            
            $qsa('.menu-item-has-children').forEach((parentEl) => {
                
                if(parentEl.classList.contains('current-page-ancestor')) {   
                    setTimeout(() => {
                        var allSubmenus = $qsa('.sub-menu-wrap');
                        allSubmenus.forEach((submenu) => {
                            submenu.classList.remove('open-submenu');
                        })
                        var submenu = $qs('.sub-menu-wrap', parentEl);
                        submenu.classList.add('open-submenu');            
                    
                        menu.setAttribute('data-state-submenu', 'closed')        
                        // sub menu;
                        if(window.innerWidth <= 575) {
                            var xPerc = 0
                            var xPercSub = -100 
                        } else {
                            var xPerc = -100
                            var xPercSub = 0
                        }
                        submenuTl.to(menu, {
                            xPercent: xPerc,
                            duration: 0.3,
                            ease: "Power4.out"
                        },">")
                        submenuTl.to(submenu, {
                            xPercent: xPercSub,
                            duration: 0.3,
                            ease: "power4.out"
                        })
                        var back = $qs('.back-menu', submenu);
                        back.addEventListener('click', () => {
                            submenuTl.to(submenu, {
                                xPercent: -1 * xPercSub,
                                duration: 0.3,
                                ease: "power4.out"
                            })
                        })
                        // Open current submenu
                        if(menu.getAttribute('data-state-submenu') == 'closed') {
                            submenuTl.play();                  
                            menu.setAttribute('data-state-submenu', 'open');
                        } else {
                            submenuTl.reverse();  
                            menu.setAttribute('data-state-submenu', 'closed')
                        }   
                    }, 300)                                          
                }
            })
        } else {
            if(menu.getAttribute('data-state-submenu') == 'open') {
                if(menu.getAttribute('data-state-submenu') == 'open') {
                    submenuTl.reverse();
                    menu.setAttribute('data-state-submenu', 'closed')
                }
                submenuTl.reverse();
                menu.setAttribute('data-state-submenu', 'closed')
            }
            menuTl.reverse();  
            menu.setAttribute('data-state', 'closed')
        }        
    })
    $qs('body').addEventListener('click', function(event) {    
        if(event.target.getAttribute('data-target') == 'menu-cover' && menu.getAttribute('data-state') == 'open') {
            if(menu.getAttribute('data-state-submenu') == 'open') {
                submenuTl.reverse();
                menu.setAttribute('data-state-submenu', 'closed')
            }
            menuTl.reverse();
            menu.setAttribute('data-state', 'closed')
        }
    })

}

function menu() {
    toggleOpenMenu();
}

export default menu;